module.exports = __webpack_public_path__ + "img/brightness-alt-low.39ca1e56.svg";